export default {
	required: () => 'validators.required',
	confirmPassordNotMatch: () => 'validators.confirmPassordNotMatch',
	multiRequired: () => 'validators.multiRequired',
	email: () => 'validators.email',
	teamResultHaveEntity: () => 'validators.teamResultHaveEntity',
	hasPosition: () => 'validators.hasPosition'
};